import API from './Api';

// eslint-disable-next-line import/prefer-default-export
export { API };



// WEBPACK FOOTER //
// ./src/arteia-js/services/index.js